import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ObservationDefinitionAddAtomicComponent } from './atomic/observation-definition-add-atomic.component';
import { ObservationDefinitionAddAggregatedComponent } from './aggregated/observation-definition-add-aggregated.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { ModalsModule } from '../../../../widgets/entry-components/modal/modals.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, TranslateModule, ModalsModule],
  declarations: [ObservationDefinitionAddAtomicComponent, ObservationDefinitionAddAggregatedComponent],
  exports: [ObservationDefinitionAddAtomicComponent, ObservationDefinitionAddAggregatedComponent]
})
export class ObservationDefinitionAddModule { }
